var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05651 4.87733C1.0709 2.73342 2.80029 1 4.95081 1H19.1057C21.2551 1 23 2.74485 23 4.8943V14.805C23 16.9545 21.2551 18.6993 19.1057 18.6993H15.4069L11.5939 22.7348C11.2727 23.0747 10.737 23.0898 10.3971 22.7687C10.0573 22.4476 10.0421 21.9118 10.3632 21.5719L14.4268 17.2713C14.5867 17.102 14.8092 17.0061 15.0421 17.0061H19.1057C20.32 17.0061 21.3068 16.0193 21.3068 14.805V4.8943C21.3068 3.67997 20.32 2.69317 19.1057 2.69317H4.95081C3.73769 2.69317 2.75806 3.66862 2.74965 4.88827L2.69322 14.7985C2.68506 16.0227 3.67174 17.0174 4.89438 17.0174H8.94666C9.41425 17.0174 9.79325 17.3964 9.79325 17.864C9.79325 18.3315 9.41425 18.7106 8.94666 18.7106H4.89438C2.73082 18.7106 0.985917 16.9505 1.00009 14.7885L1.05651 4.87733ZM6.76757 7.40018C6.76757 6.93259 7.14664 6.55359 7.61416 6.55359H16.3736C16.8411 6.55359 17.2201 6.93259 17.2201 7.40018C17.2201 7.86769 16.8411 8.24676 16.3736 8.24676H7.61416C7.14664 8.24676 6.76757 7.86769 6.76757 7.40018ZM7.61416 10.6172C7.14664 10.6172 6.76757 10.9962 6.76757 11.4638C6.76757 11.9313 7.14664 12.3104 7.61416 12.3104H11.9939C12.4614 12.3104 12.8404 11.9313 12.8404 11.4638C12.8404 10.9962 12.4614 10.6172 11.9939 10.6172H7.61416Z",
    fill: "#152FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic_chat.eb0bfb601d870ded30de50712e2f08af.svg";
export { ForwardRef as ReactComponent };